import { Stack, Tooltip, Chip } from '@mui/material';
import { TransactionType, OfferType } from '../graphql/types';

import ManualLogo from 'assets/images/transaction-types/MANUAL.svg';
import SyndicationLogo from 'assets/images/transaction-types/SYNDICATION.svg';
import RefundLogo from 'assets/images/transaction-types/REFUND.svg';
import FeeLogo from 'assets/images/transaction-types/FEE.svg';
import FundingWalletLogo from 'assets/images/transaction-types/FUNDING_WALLET.svg';
import RemittanceLogo from 'assets/images/transaction-types/REMITTANCE.svg';
import RemittanceFeeLogo from 'assets/images/transaction-types/REMITTANCE_FEE.svg';
import ExpenseLogo from 'assets/images/transaction-types/EXPENSE.svg';
import CRMAcessFeeLogo from 'assets/images/transaction-types/CRMACCESSFEE.svg';
import RegularLogo from 'assets/images/offer-types/OFFER_TYPE_REGULAR.svg';
import RehabLogo from 'assets/images/offer-types/OFFER_TYPE_REHAB.svg';
import CustomTooltip from 'components/CustomTooltip';

const transactionTypeToLogo = new Map<TransactionType, string>([
  [TransactionType.Collection, ManualLogo],
  [TransactionType.Syndication, SyndicationLogo],
  [TransactionType.Refund, RefundLogo],
  [TransactionType.DefaultFee, FeeLogo],
  [TransactionType.AchProgramFee, FeeLogo],
  [TransactionType.NsfFee, FeeLogo],
  [TransactionType.FundingWallet, FundingWalletLogo],
  [TransactionType.Remittance, RemittanceLogo],
  [TransactionType.RemittanceFee, RemittanceFeeLogo],
  [TransactionType.Expense, ExpenseLogo],
  [TransactionType.CrmAccessFee, CRMAcessFeeLogo],
  [TransactionType.OtherFee, FeeLogo]
]);

const offerTypeToLogo = new Map<OfferType, string>([
  [OfferType.Regular, RegularLogo],
  [OfferType.Rehab, RehabLogo]
]);

const TransactionsTypeLogo = ({
  type,
  size,
  mt = 1,
  ...props
}: {
  type: TransactionType | OfferType;
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  mt?: number;
}) => {
  const logoPath =
    transactionTypeToLogo.get(type as TransactionType) ||
    offerTypeToLogo.get(type as OfferType);

  if (!logoPath) return null;

  return (
    <Stack direction="row" spacing={-1.5} mt={mt} {...props}>
      <CustomTooltip
        title={String(type)}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'transparent',
              boxShadow: 'none'
            }
          }
        }}
      >
        <img
          src={logoPath}
          alt={String(type)}
          style={{
            width: size === 'xs' ? 24 : 32,
            height: size === 'xs' ? 24 : 32
          }}
        />
      </CustomTooltip>
    </Stack>
  );
};

export default TransactionsTypeLogo;
